._more_rzykk_1 {
  margin: 0 24px;
  font-size: 13px;
  padding: 16px 0;
  border-top: 1px solid #d9e1e8;
  color: #7a92a5;
  font-weight: 300;
  line-height: 21px; }

._more_rzykk_1 ._symbolMarket_rzykk_10 {
  position: relative;
  left: 3px;
  top: 3px; }

._stillHaventFoundText_rzykk_15 {
  margin-left: 11px; }

._openWixAppMarketLink_rzykk_18 {
  display: block;
  font-size: 13px !important;
  margin-left: 28px;
  height: unset; }

._actionItem_rzykk_24 {
  padding: 12px 24px 12px 17px; }

._stillHaventFoundTextWrapper_rzykk_27 {
  display: flex;
  justify-content: flex-start;
  align-items: center; }
